import React, { useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { sendEnquiry } from '../lib/sendEnquiry';
import Seo from '../Components/Seo';
import { breadcrumbSchema, organizationSchema } from '../data/seo';
import '../assests/css/register-demo.css';

const initialForm = {
  name: '',
  designation: '',
  mobile: '',
  location: '',
  school: '',
  students: '',
  email: '',
  needs: '',
  website: '',
};

function RegisterDemo() {
  const [form, setForm] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (form.website) return;

    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      await sendEnquiry(
        {
          name: form.name,
          designation: form.designation,
          mobile: form.mobile,
          location: form.location,
          school: form.school,
          'number of students': form.students,
          email: form.email,
          'specify your needs': form.needs,
        },
        `Bright Study demo request from ${form.name}`
      );

      setStatus({
        type: 'success',
        message: 'Thank you. Your demo request has been sent. Our team will reach out shortly.',
      });
      setForm(initialForm);
    } catch (error) {
      setStatus({
        type: 'error',
        message:
          error.message ||
          'Something went wrong while sending your request. Please try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="demo-page">
      <Seo
        path="/register-for-demo"
        schema={[organizationSchema, breadcrumbSchema('/register-for-demo', 'Book a Demo')]}
      />
      <Header />
      <main className="demo-main">
        <div className="container">
          <form className="demo-card" onSubmit={onSubmit}>
            <h1>
              Register for a <span>Demo</span>
            </h1>
            <p className="demo-lead">
              Share a few details about your school and we’ll set up a walkthrough of Bright Study.
            </p>

            <div className="demo-grid">
              <label>
                Name
                <input
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  placeholder="Full Name"
                  required
                />
              </label>
              <label>
                Designation
                <input
                  name="designation"
                  value={form.designation}
                  onChange={onChange}
                  placeholder="Designation"
                  required
                />
              </label>
              <label>
                Mobile Number
                <input
                  name="mobile"
                  type="tel"
                  value={form.mobile}
                  onChange={onChange}
                  placeholder="Mobile Number"
                  required
                />
              </label>
              <label>
                Location
                <input
                  name="location"
                  value={form.location}
                  onChange={onChange}
                  placeholder="Location"
                  required
                />
              </label>
              <label>
                School Name
                <input
                  name="school"
                  value={form.school}
                  onChange={onChange}
                  placeholder="School Name"
                  required
                />
              </label>
              <label>
                Number Of Students
                <input
                  name="students"
                  value={form.students}
                  onChange={onChange}
                  placeholder="Student Strength"
                />
              </label>
              <label>
                Email ID
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="Email"
                  required
                />
              </label>
              <label>
                Specify Your Needs
                <input
                  name="needs"
                  value={form.needs}
                  onChange={onChange}
                  placeholder="Specify Your Needs"
                />
              </label>
            </div>

            <input
              className="demo-honey"
              name="website"
              value={form.website}
              onChange={onChange}
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
            />

            {status.message ? (
              <p className={`demo-status is-${status.type}`}>{status.message}</p>
            ) : null}

            <button type="submit" className="demo-submit" disabled={isSubmitting}>
              {isSubmitting ? 'Sending…' : 'Submit'}
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default RegisterDemo;
